module.exports = __webpack_public_path__ + "static/media/fire-safes-fp.d1d3a4cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/model-serial-number/fire-safes-fp.png
// module id = 1290
// module chunks = 0